import ComponentModule from 'lib/component-module';
import fetcher from 'lib/fetcher';
import store from '../store';

import {
    content as recentPostsContentTemplate,
    paginator as recentPostsPaginatorTemplate,
} from 'lib/template-strings/recent-posts';

ComponentModule.AddModule('.recent-posts', {
    prefix: 'recent-posts-',
    components: [
        fetcher({
            data: function(){
                const data = {
                    data: {
                        firstLoad: true,
                        keepContent: true,
                        results: [],
                        store: store,
                    }
                };

                return data;
            },
            computed: {
                language: function() {
                    return store.state.currentLang;
                },
                taggingMetaMarket: function() {
                    return JSON.stringify({
                        "type": "dropdown",
                        "category": "Dropdown",
                        "action": this.params.market,
                        "label": "Market",
                    });        
                },
                taggingMetaTechnology: function() {
                    return JSON.stringify({
                        "type": "dropdown",
                        "category": "Dropdown",
                        "action": this.params.technology,
                        "label": "Technology",
                    });        
                },
                taggingMetaProductLine: function() {
                    return JSON.stringify({
                        "type": "dropdown",
                        "category": "Dropdown",
                        "action": this.params.productLine,
                        "label": "Post Type",
                    });        
                }

            },
            watch: {
                "language": function() {
                    this.params.lang = this.language;
                }
            },
            methods: {
                loadMore: function(e){
                    const _this = this;

                    this.fetch(function(response){
                        let _results =  [];
                        let keepContent = false;
                        const { results, ...data } = response.data || {};

                        if (!results) {
                            return false;
                        }

                        if (_this.data && _this.data.results) {
                            _results = _this.data.results;
                            keepContent = _this.data.keepContent;
                        }

                        _this.data = {
                            ...data,
                            results: [
                                ..._results,
                                ...results,
                            ],
                            keepContent,
                            showPaginator: data.currentPage < data.totalPages,
                        };
                    }, {
                        params: {
                            ...this.params,
                            page: (this.data && this.data.nextPage) || 2,
                            pageSize: 8,
                        }
                    });
                },
            },
            components: {
                'recent-posts-paginator' : {
                    props: ['data', 'isShow'],
                    template: recentPostsPaginatorTemplate,
                },
                'recent-posts-content' : {
                    props: ['data'],
                    template: recentPostsContentTemplate,
                }
            }
        })
    ]
});
